module.exports = __webpack_public_path__ + "img/portugal-endocrine-nutritional-metabolic-diseases-female.5e846e33.png";